import { render, staticRenderFns } from "./sincronizar.vue?vue&type=template&id=14675471"
import script from "./sincronizar.vue?vue&type=script&lang=js"
export * from "./sincronizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports